module.exports = __webpack_public_path__ + "static/media/outlook_color_icon.5c440ee4.png";